import React, { FC } from "react";
import { useLocation } from "Hooks/useRouter";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import { matchPath } from "react-router";
import { NavListItem } from "../NavListItem/NavListItem";
import { NavListItemText } from "../NavListItem/NavListItemText/NavListItemText";
import useStyles from "./styles";

export type Props = {
  to: string;
  label: string;
  exact?: boolean;
};

const NavItemChild: FC<Props> = ({ to, label, exact }) => {
  const { pathname } = useLocation();

  const isSelected = !!matchPath<boolean>(pathname, { path: to, exact });

  const classes = useStyles({ isSelected });
  return (
    <Link to={to} component={RouterLink} underline="none">
      <NavListItem
        button
        selected={isSelected}
        classes={{
          root: classes.navItemWrapper,
        }}>
        <NavListItemText
          className={classes.navItem}
          primary={label}
          classes={{ primary: classes.text }}
        />
      </NavListItem>
    </Link>
  );
};

export default NavItemChild;
